export function authHeaders(token: string): Record<string, string> {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export const offsetToPage = (offset: number, limit: number): number =>
  Math.floor(offset / Math.max(1, limit)) + 1;

export const ONBOARDING_INCOMPLETE_ERROR = "ONBOARDING_INCOMPLETE";

export async function handleError(
  response: Response,
  fallback: string,
): Promise<never> {
  if (response.status === 403) {
    const body = await response.json().catch(() => null);
    if (
      body &&
      typeof body === "object" &&
      (body as { code?: string }).code === ONBOARDING_INCOMPLETE_ERROR
    ) {
      throw new Error(ONBOARDING_INCOMPLETE_ERROR);
    }
    throw new Error("No tienes permiso para realizar esta accion");
  }
  const body = await response.json().catch(() => null);
  throw new Error(
    (body as { error?: string } | null)?.error ||
      response.statusText ||
      fallback,
  );
}

export async function handleV2Error(response: Response): Promise<never> {
  const body = await response.json().catch(() => null);
  const apiError = (body as { errors?: { message?: string }[] } | null)
    ?.errors?.[0];
  throw new Error(apiError?.message || response.statusText || "Error");
}
